import React from "react";

export default function MiddleDot() {
  return (
    <div style={{ marginLeft: 3, marginRight: 3, fontWeight: "bold" }}>·</div>
  );
}
